<div class="products">
  @if (recommendedProducts && recommendedProducts.length > 0) {
    <h3 class="products-subTitle">
    {{allProducts.RecommendedProductsHeader}}</h3>
  }
  @if (recommendedProducts.length > 0) {
    <p class="products-subText"> {{allProducts.RecommendedProductsText}}</p>
  }
  <div class="products-available">
    <div class="products-available-container">
      @for (product of recommendedProducts; track product) {
        <div class="products-available-container-wrapper">
          @if (product.displayProduct && filterProducts(product)) {
            <div
              class="products-container-body">
              <app-product [product]="product" (selectedProduct)="selectProduct(product)" [alternateProductsExist] = "alternateProductsExist">
              </app-product>
            </div>
          }
        </div>
      }
    </div>
  </div>
  @if (alternateProducts && alternateProducts.length > 0) {
    <h3 class="products-subTitle">
    {{allProducts.AlternateProductsHeader}}</h3>
  }
  @if (alternateProducts.length > 0) {
    <p class="products-subText"> {{allProducts.AlternateProductsText}}</p>
  }
  <div class="products-available">
    <div class="products-available-container">
      @for (product of alternateProducts; track product) {
        <div class="products-available-container-wrapper">
          @if (product.displayProduct && filterProducts(product)) {
            <div
              class="products-container-body">
              <app-product [product]="product" (selectedProduct)="selectProduct(product)" [alternateProductsExist] = "alternateProductsExist">
              </app-product>
            </div>
          }
        </div>
      }
    </div>
  </div>
  @if (!isFirstconnAgent && unavailableProducts && unavailableProducts.length > 0) {
    <h3 class="products-subTitle">
    {{allProducts.UnavailableProductsHeader}}</h3>
  }
  @if (!isFirstconnAgent && unavailableProducts.length > 0) {
    <p class="products-subText"> {{allProducts.UnavailableProductsText}}</p>
  }
  @if (!isFirstconnAgent) {
    <div class="products-unAvailable">
      <div class="products-unAvailable-container">
        @for (product of unavailableProducts; track product) {
          <div class="products-unAvailable-container-wrapper">
            @if (filterProducts(product)) {
              <div
                class="products-container-body">
                <app-product [showUmbrellaError]="showUmbrellaError"
                  (emitUmbrellaError)="closeMessage($event)" [product]="product"
                  (selectedProduct)="selectProduct(product)" [alternateProductsExist] = "alternateProductsExist">
                </app-product>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>